/**
 * Post Tabs Handler
 *
 * Creates click handlers that switch shared post tabs and trigger preview refreshes.
 */

import { postTabsForm } from "./post-tabs-form";

interface CreateTabClickHandlerParams {
    tab: Element;
    tabs: Element[];
    panels: Element[];
    rootEl: Document | HTMLElement;
    onPreview: () => void;
}

class PostSharedTabsHandler {
    public static createTabClickHandler(params: CreateTabClickHandlerParams): (event: Event) => void {
        const { tab, tabs, panels, rootEl, onPreview } = params;

        return (event: Event): void => {
            event.preventDefault();
            event.stopPropagation();

            const targetKey = tab.getAttribute("data-tab") || "";

            tabs.forEach((tabElement) => {
                tabElement.classList.remove("is-active", "active");
                tabElement.setAttribute("aria-selected", "false");
            });
            tab.classList.add("is-active", "active");
            tab.setAttribute("aria-selected", "true");

            panels.forEach((panel) => {
                panel.classList.remove("is-active", "active");
                panel.setAttribute("hidden", "");
                if (panel instanceof HTMLElement) {
                    panel.style.display = "none";
                }
            });

            const targetPanel = postTabsForm.getTargetPanel(rootEl, targetKey);
            if (!(targetPanel instanceof HTMLElement)) return;

            targetPanel.classList.add("is-active", "active");
            targetPanel.removeAttribute("hidden");
            targetPanel.style.display = "block";

            if (targetKey === "preview") {
                onPreview();
            }
        };
    }
}

export { PostSharedTabsHandler };
